import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Breadcrumbコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/breadcrumb?background=transparent&version=react" target="_blank">こちら</a><br>
 * ※Appkit3では「/」でしたがAppkit4で「>」に変更になりました。
 */
export const Breadcrumb = ({ ...props }) => {
    return <View {...props} />
}

Breadcrumb.propTypes = {
    /**
     * パンくずのテキストとリンク<font color="red">*</font>
     */
    itemList: PropTypes.arrayOf(
        PropTypes.exact({
            link: PropTypes.string,
            text: PropTypes.string
        })
    ).isRequired,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Breadcrumb.defaultProps = {
    itemList: []
}
